import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { FilterBarActionButton, FilterResult, FiltersConfig } from '../../models/filter.interface';
import { PaButtonComponent } from 'src/app/shared/ui-kit/pa-button/pa-button.component';
import { PaContextMenuComponent } from 'src/app/shared/ui-kit/pa-context-menu/pa-context-menu.component';
import { ChipFiltersComponent } from '../chip-filters/chip-filters.component';

@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
  standalone: true,
  imports: [PaButtonComponent, PaContextMenuComponent, CommonModule, TooltipModule, ChipFiltersComponent],
})
export class FilterBarComponent implements OnChanges, OnInit {
  @Input() config: FilterResult;
  @Input() filtersConfigForChips: FiltersConfig | null = null;
  @Input() filterResultForChips: FilterResult | null = null;
  @Input() showAddButton = true;
  @Input() addButtonLabel = 'Добавить';
  @Input() addButtonIcon = 'pi pi-plus';
  @Input() addButtonSeverity:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warn'
    | 'danger'
    | 'help'
    | 'profi' = 'primary';
  @Input() showFilterButton = true;
  @Input() actionButtons: FilterBarActionButton[] = [];
  @Output() addClick = new EventEmitter<Event>();
  @Output() filterClick = new EventEmitter<void>();
  @Output() chipRemove = new EventEmitter<string>();
  @Output() chipClick = new EventEmitter<string>();

  menuActionItems: MenuItem[] = [];
  isMobileView = false;

  @HostListener('window:resize')
  onResize(): void {
    this.updateMobileView();
  }

  ngOnInit(): void {
    this.updateMobileView();
    this.updateMenuActionItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['actionButtons']) {
      this.updateMenuActionItems();
    }
  }

  isButtonVisible(button: FilterBarActionButton): boolean {
    return !this.getEffectiveInMenuOnly(button);
  }

  private getEffectiveInMenuOnly(button: FilterBarActionButton): boolean {
    return this.isMobileView || (button.inMenuOnly ?? false);
  }

  private updateMobileView(): void {
    const wasMobile = this.isMobileView;
    this.isMobileView = window.innerWidth < 1200;
    if (wasMobile !== this.isMobileView) {
      this.updateMenuActionItems();
    }
  }

  private updateMenuActionItems(): void {
    const buttons = this.actionButtons ?? [];

    this.menuActionItems = buttons
      .filter((button) => this.getEffectiveInMenuOnly(button))
      .map((button) => ({
        label: button.label,
        icon: button.icon,
        command: () => button.action(),
        title: button.tooltip,
      }));
  }

  handleAddClick(event?: Event): void {
    this.addClick.emit(event);
  }

  handleFilterClick(): void {
    this.filterClick.emit();
  }

  handleChipRemove(key: string): void {
    this.chipRemove.emit(key);
  }

  handleChipClick(key: string): void {
    this.chipClick.emit(key);
  }
}
